export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.993d20c1.worker.js");
}
